var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg011Cart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6H5C5 4.34315 3.65685 3 2 3C1.44772 3 1 3.44772 1 4C1 4.55228 1.44772 5 2 5C2.26522 5 2.51957 5.10536 2.70711 5.29289C2.89464 5.48043 3 5.73478 3 6V13C3 14.6569 4.34315 16 6 16H17.65C19.4803 16.0078 21.0824 14.7722 21.54 13L23 7.24C23.0759 6.94092 23.0095 6.62354 22.82 6.38C22.6228 6.13 22.3182 5.98888 22 6ZM19.6 12.48C19.3744 13.3944 18.5414 14.0274 17.6 14H6C5.44772 14 5 13.5523 5 13V8H20.72L19.6 12.48ZM9 19C9 20.1046 8.10457 21 7 21C5.89543 21 5 20.1046 5 19C5 17.8954 5.89543 17 7 17C8.10457 17 9 17.8954 9 19ZM19 19C19 20.1046 18.1046 21 17 21C15.8954 21 15 20.1046 15 19C15 17.8954 15.8954 17 17 17C18.1046 17 19 17.8954 19 19Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg011Cart);
export default __webpack_public_path__ + "static/media/011-cart.da85accf9998ecf4420b0df7b4f74bb5.svg";
export { ForwardRef as ReactComponent };